import get from 'hs-lodash/get';
const getDynoGuid = state => get(state, 'dynosEditor.editableDyno.formGuid', '');
export default getDynoGuid;